

































import { Component, Prop, Vue } from 'vue-property-decorator';
import { DateTime } from 'luxon';
import { TimeEntryDay, TimeEntryDayApprovalEnum } from '@/services/api/nswag/stapiclient_generated';
import { UserStore } from '@/store/user-module';
import { NotCriticalWarningEnums } from "@/views/TeamOverview/team-overview-approval-icon";

@Component({
  components: {},
})
export default class DateSliderItem extends Vue {
  @Prop() active!: boolean;
  @Prop() day!: TimeEntryDay;
  @Prop() loading: boolean;

  get isWorkDay() {
    return this.day?.appUserDay?.dayDescription?.isWorkDay;
  }

  get useTimeApproval() {
    return UserStore.userSettings.needsTimeEntryApproval;
  }

  get approvalBgColor() {
    if (this.day?.appUserDay?.timeEntryDayApproval) {
      switch (this.day.appUserDay.timeEntryDayApproval.approvalEnum) {
        case TimeEntryDayApprovalEnum.IsDeclined:
          return 'bg-red-500';
        case TimeEntryDayApprovalEnum.IsApproved:
          return 'bg-green-500';
        case TimeEntryDayApprovalEnum.IsSubmitted:
          return 'bg-orange-500';
        case TimeEntryDayApprovalEnum.IsSubmittedImplicitly:
          return 'bg-orange-300';
      }
    }
    return '';
  }

  get approvalIcon(): string {
    if (this.loading) {
      return 'far fa-spinner fa-spin';
    }

    if (this.day?.appUserDay?.timeEntryDayApproval) {
      switch (this.day.appUserDay.timeEntryDayApproval.approvalEnum) {
        case TimeEntryDayApprovalEnum.IsDeclined:
          return 'far fa-times text-white';
        case TimeEntryDayApprovalEnum.IsApproved:
          return 'far fa-check text-white';
        case TimeEntryDayApprovalEnum.IsSubmitted:
          return 'far fa-inbox-out text-white';
        case TimeEntryDayApprovalEnum.IsSubmittedImplicitly:
          return 'far fa-lock text-white';
        default:
          return 'far fa-user';
      }
    }

    return 'fa fa-user';
  }

  get approvalTooltip(): any {
    let text = '';

    if (this.day?.appUserDay?.timeEntryDayApproval) {
      switch (this.day.appUserDay.timeEntryDayApproval.approvalEnum) {
        case TimeEntryDayApprovalEnum.IsDeclined:
          text = 'Abgelehnt<br>';
          break;
        case TimeEntryDayApprovalEnum.IsApproved:
          text = 'Freigegeben<br>';
          break;
        case TimeEntryDayApprovalEnum.IsSubmitted:
          text = 'Abgegeben';
          break;
        case TimeEntryDayApprovalEnum.IsSubmittedImplicitly:
          text = 'Gesperrt';
          break;
        default:
          return '';
      }
    }

      if (this.day?.appUserDay?.timeEntryDayApproval?.comment) {
        text += '<i class="far fa-user mr-2"></i>' + this.day.appUserDay.timeEntryDayApproval.comment;
      }

    return {
      content: text,
      placement: 'bottom'
    };
  }

  get primaryColorIsDark() {
    return UserStore.primaryColorIsDark;
  }

  get badge() {
    return this.day?.appUserDay?.dayDescription?.badgeText;
  }

  get hasViolatedRules(){
    return this.day?.appUserDay?.violatedValidationRules?.filter(x=>!NotCriticalWarningEnums.includes(x?.ruleEnum))?.length;
  }

  get hasEntries() {
    return this.day?.timeEntries?.length;
  }

  get dayDateTime() {
    if (!this.day?.entryDay) {
      return UserStore.userNowDateTime;
    }

    return DateTime.fromISO(this.day.entryDay!);
  }
}
